import { render, staticRenderFns } from "./OnBoard.vue?vue&type=template&id=8e1ecea4&"
import script from "./OnBoard.vue?vue&type=script&lang=js&"
export * from "./OnBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports